import React, { FunctionComponent } from 'react';

import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import 'common/response-editor/error-message/ErrorMessage.scss';

type ErrorMessageProps = {
    errorCount: number;
    onClose: () => void;
};

export const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({ errorCount, onClose }) => {
    const { t } = useTranslation(['common/response-editor']);

    return (
        <div className={`error-container${errorCount > 2 ? ' error-container--big' : ''}`}>
            <div>{errorCount > 2 ? t('MULTIPLE_ERROR_MESSAGE') : t('ERROR_MESSAGE')}</div>
            <Button className="close error-close-button" onClick={() => onClose()}>
                <i className="icon-times close-icon" aria-hidden="true" />
            </Button>
        </div>
    );
};
